import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminLogin = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({ username: '', password: '' });
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (localStorage.getItem('admin_token')) navigate('/admin/dashboard');
  }, [navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await axios.post(`${API}/admin/login`, form);
      localStorage.setItem('admin_token', data.token);
      localStorage.setItem('admin_user', data.username);
      toast.success('Willkommen zurück!');
      navigate('/admin/dashboard');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Login fehlgeschlagen');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="bg-charcoal min-h-screen flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="w-14 h-14 rounded-full bg-yellow flex items-center justify-center mx-auto mb-4">
            <Lock className="w-7 h-7 text-[#1a1a1a]" />
          </div>
          <h1 className="font-display text-yellow text-3xl">Admin-Bereich</h1>
          <p className="text-zinc-400 mt-2 text-sm">LLIT-Media Verwaltung</p>
        </div>
        <form onSubmit={submit} className="bg-[#252525] rounded-lg p-8 border border-zinc-800 space-y-5">
          <div>
            <label className="text-yellow text-sm font-semibold" htmlFor="username">Benutzername</label>
            <input
              id="username"
              autoFocus
              value={form.username}
              onChange={(e) => setForm({ ...form, username: e.target.value })}
              className="mt-1 w-full bg-transparent border-b-2 border-zinc-600 focus:border-yellow outline-none py-2 text-white"
            />
          </div>
          <div>
            <label className="text-yellow text-sm font-semibold" htmlFor="password">Passwort</label>
            <input
              id="password"
              type="password"
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              className="mt-1 w-full bg-transparent border-b-2 border-zinc-600 focus:border-yellow outline-none py-2 text-white"
            />
          </div>
          <button type="submit" disabled={busy} className="btn-yellow w-full justify-center disabled:opacity-70">
            {busy ? 'Einloggen...' : 'Einloggen'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
